import { lazy } from 'react'

export const Checkout = lazy(() => import('./Checkout'))

export const ProductView = lazy(() => import('./ProductView'))

export const DoorCoreView = lazy(() => import('./DoorCoreView'))

export const SealProductView = lazy(() => import('./SealProductView'))

export const MasterProductView = lazy(() => import('./MasterProductView'))

export const OrderConfirmation = lazy(() => import('./OrderConfirmation'))

export const QuoteSubmitted = lazy(() => import('./QuoteSubmitted'))

export const ProductsHome = lazy(() => import('./ProductsHome'))

// export const RequestQuote = lazy(() => import('./RequestQuote'))

export const YourBasket = lazy(() => import('./YourBasket'))

export const OverlapBasket = lazy(() => import('./OverlapBasket'))

export const HardwareHome = lazy(() => import('./ProductsHome/HardwareHome'))

export const ProductList = lazy(() => import('./ProductList'))